import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bgColor", "color", "style", "invert", "customColors"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var iconSizeMap = {
  s: 's',
  m: 'm',
  l: 'm'
};
export var avatarSizeMap = {
  s: 32,
  m: 44,
  l: 56
};
export var textSizeMap = {
  s: 'body-accent-small',
  m: 'body-accent-small',
  l: 'body-accent-medium'
};
export var getInitialsForName = function getInitialsForName(name) {
  var _words$0$, _words$, _words$1$, _words$2;
  if (!name) {
    return '';
  }
  if (name.charAt(0) === '+') {
    return name;
  }
  var words = name.split(' ');
  return "".concat(((_words$0$ = (_words$ = words[0]) === null || _words$ === void 0 ? void 0 : _words$[0]) !== null && _words$0$ !== void 0 ? _words$0$ : '').toUpperCase()).concat(((_words$1$ = (_words$2 = words[1]) === null || _words$2 === void 0 ? void 0 : _words$2[0]) !== null && _words$1$ !== void 0 ? _words$1$ : '').toUpperCase());
};
var getAvatarMode = function getAvatarMode(_ref) {
  var image = _ref.image,
    icon = _ref.icon,
    logo = _ref.logo;
  if (image) {
    return 'image';
  }
  if (icon) {
    return 'icon';
  }
  if (logo) {
    return 'logo';
  }
  return 'text';
};
export var bgColorsMap = {
  primary: 'primary',
  default: 'default-on-primary',
  invert: 'default-on-secondary',
  'default-on-primary': 'default-on-primary',
  'default-on-secondary': 'default-on-secondary',
  'default-on-tertiary': 'default-on-tertiary',
  dark: 'dark'
};
var newColors = ['default-on-primary', 'default-on-secondary', 'default-on-tertiary', 'brand', 'invert'];
var defaultColors = {
  '--avatar-bg': 'var(--avatar-bg-default-on-primary)',
  '--avatar-color': 'var(--avatar-color-default-on-primary)',
  '--avatar-bg-disabled': 'var(--avatar-bg-default-on-primary-disabled)',
  '--avatar-color-disabled': 'var(--avatar-color-default-on-primary-disabled)'
};
var getColors = function getColors(_ref2) {
  var _ref2$bgColor = _ref2.bgColor,
    bgColorProp = _ref2$bgColor === void 0 ? 'default-on-primary' : _ref2$bgColor,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    invert = _ref2.invert,
    type = _ref2.type;
  if (type !== 'icon' && type !== 'text') {
    return defaultColors;
  }
  if (color && newColors.includes(color)) {
    return {
      '--avatar-bg': "var(--avatar-bg-".concat(color, ")"),
      '--avatar-color': "var(--avatar-".concat(type === 'icon' ? 'icon' : 'color', "-").concat(color, ")"),
      '--avatar-bg-disabled': "var(--avatar-bg-".concat(color, "-disabled)"),
      '--avatar-color-disabled': "var(--avatar-color-".concat(color, "-disabled)")
    };
  }
  var bgColor = invert ? 'default-on-secondary' : bgColorsMap[bgColorProp];
  var disableSuffix = "".concat(bgColor, "-disabled");
  return {
    '--avatar-bg': "var(--avatar-".concat(type, "-bg-").concat(type === 'text' ? color : bgColor, ")"),
    '--avatar-color': "var(--avatar-".concat(type, "-color-").concat(type === 'text' ? color : bgColor, ")"),
    '--avatar-bg-disabled': "var(--avatar-".concat(type, "-bg-").concat(type === 'text' ? 'disabled' : disableSuffix, ")"),
    '--avatar-color-disabled': "var(--avatar-".concat(type, "-color-").concat(type === 'text' ? 'disabled' : disableSuffix, ")")
  };
};
export var dataConverter = function dataConverter(_ref3) {
  var bgColor = _ref3.bgColor,
    color = _ref3.color,
    style = _ref3.style,
    invert = _ref3.invert,
    customColors = _ref3.customColors,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  var type = getAvatarMode(otherProps);
  var colorStyles = getColors({
    type: type,
    bgColor: bgColor,
    invert: invert,
    color: color
  });
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    type: type,
    color: color,
    bgColor: bgColor,
    style: _objectSpread(_objectSpread(_objectSpread({}, style), colorStyles), {}, {
      '--avatar-bg': (customColors === null || customColors === void 0 ? void 0 : customColors.bg) || colorStyles['--avatar-bg'],
      '--avatar-color': (customColors === null || customColors === void 0 ? void 0 : customColors.content) || colorStyles['--avatar-color']
    })
  });
};